// src/lib/permissions.js
//
// The fixed set of admin sections a role can be granted access to. Adding
// a new admin page later just means adding one entry here and wrapping its
// route with <AdminRoute require="key">.
export const PERMISSION_SECTIONS = [
  { key: "overview",   label: "Overview" },
  { key: "leads",      label: "Leads" },
  { key: "businesses", label: "Businesses" },
  { key: "website",    label: "Website Management" },
  { key: "google",     label: "Google Posts" },
  { key: "reviews",    label: "All Reviews" },
  { key: "campaigns",  label: "Campaigns" },
  { key: "auditLog",   label: "Audit Log" },
  { key: "testChat",   label: "Test the AI" },
];

// Finer-grained than a section: these gate specific sensitive actions
// *within* the Businesses page, rather than visibility of a whole page.
// Someone can see Businesses (the section above) without being able to do
// either of these — they're opt-in extras, not implied by section access.
export const PERMISSION_ACTIONS = [
  { key: "canImpersonate",   label: "Proxy login — sign in as a client to troubleshoot" },
  { key: "canGrantAccess",   label: "Grant client access — unlock Zilo / website after signup" },
];

export function emptyPermissions() {
  const perms = {};
  PERMISSION_SECTIONS.forEach(s => { perms[s.key] = false; });
  PERMISSION_ACTIONS.forEach(a => { perms[a.key] = false; });
  return perms;
}

// Super admins bypass this entirely — this is only consulted for staff
// with a specific role assigned.
export function hasPermission(businessProfile, key) {
  if (!businessProfile) return false;
  if (businessProfile.superAdmin) return true;
  return !!businessProfile.permissions?.[key];
}
